if (!customElements.get('notcoy-secondary-media')) {
  class NotcoySecondaryMedia extends HTMLElement {
    constructor() {
      super();
      this.onMove = this.onMove.bind(this);
      this.onLeave = this.onLeave.bind(this);
    }

    connectedCallback() {
      if (!this.stopObserving) {
        this.stopObserving = Motion.inView(this, () => { this.init(); }, { margin: '200px 0px 200px 0px' });
      }
    }

    disconnectedCallback() {
      this.stopObserving?.();
      this.stopObserving = null;
      this.loadController?.abort();
      this.loadController = null;
      this.carousel?.destroy();
      this.carousel = null;
      this.removeEventListener('mousemove', this.onMove);
      this.removeEventListener('mouseleave', this.onLeave);
      this.removeAttribute('data-ready');
      this.replaceChildren();
    }

    async init() {
      if (this.loadController || !this.isConnected) return;
      const template = this.previousElementSibling;
      if (!(template instanceof HTMLTemplateElement)) return;
      const controller = new AbortController();
      this.loadController = controller;
      const { signal } = controller;
      this.appendChild(template.content.cloneNode(true));
      const firstImage = this.querySelector('.media img');
      if (!firstImage) return;
      firstImage.loading = 'eager';

      try {
        await new Promise((resolve, reject) => {
          if (firstImage.complete) {
            firstImage.naturalWidth > 0 ? resolve() : reject(new Error('Image unavailable'));
            return;
          }
          firstImage.addEventListener('load', resolve, { once: true, signal });
          firstImage.addEventListener('error', reject, { once: true, signal });
          signal.addEventListener('abort', reject, { once: true });
        });
        if (!firstImage.naturalWidth || signal.aborted || !this.isConnected) return;
        if (firstImage.decode) await firstImage.decode();
        if (signal.aborted || !this.isConnected) return;
        this.mediaCount = this.querySelectorAll('.media').length;
        if (this.mediaCount > 1) {
          this.carousel = new Flickity(this, {
            accessibility: false,
            draggable: false,
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            rightToLeft: theme.config.rtl,
          });
          if (this.mediaCount === 2) this.classList.add('without-dots');
          this.addEventListener('mousemove', this.onMove);
          this.addEventListener('mouseleave', this.onLeave);
        }
        this.setAttribute('data-ready', '');
      } catch {
        if (this.loadController === controller && !signal.aborted) this.removeAttribute('data-ready');
      }
    }

    onMove(event) {
      if (!this.carousel || !this.hasAttribute('data-ready')) return;
      if (this.mediaCount === 2) return this.carousel.select(1);
      const width = this.carousel.size.width;
      const mouseX = event.clientX - this.getBoundingClientRect().left;
      if (this.mediaCount === 3) return this.carousel.select(mouseX < width / 2 ? 1 : 2);
      if (this.mediaCount === 4) return this.carousel.select(mouseX < width / 3 ? 1 : mouseX < 2 * width / 3 ? 2 : 3);
    }

    onLeave() {
      if (this.carousel && this.hasAttribute('data-ready')) this.carousel.select(0);
    }
  }
  customElements.define('notcoy-secondary-media', NotcoySecondaryMedia);
}
